module.exports = {
    RECEIVE_ALTIMETRIC_SYSTEM_PRODUCTION_MODE: 'RECEIVE_ALTIMETRIC_SYSTEM_PRODUCTION_MODE',
    RECEIVE_ALTIMETRIC_SYSTEM_NATURE: 'RECEIVE_ALTIMETRIC_SYSTEM_NATURE',
    RECEIVE_ALTIMETRIC_SYSTEM_ALTIMETRIC_SYSTEM: 'RECEIVE_ALTIMETRIC_SYSTEM_ALTIMETRIC_SYSTEM',
}
